export var SET_PARAMS = "SET_PARAMS";
export var DRIVING_MKT_SET_MSG = "DRIVING_MKT_SET_MSG";
export var DRIVING_MKT_CLEAR_MSG = "DRIVING_MKT_CLEAR_MSG";
